import { render } from "./TrfDateInput.vue?vue&type=template&id=18d8b3e9&scoped=true"
import script from "./TrfDateInput.vue?vue&type=script&lang=js"
export * from "./TrfDateInput.vue?vue&type=script&lang=js"

import "./TrfDateInput.vue?vue&type=style&index=0&id=18d8b3e9&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d8b3e9"],['__file',"src/components/Input/TrfDateInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18d8b3e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18d8b3e9', __exports__)) {
    console.log('reload')
    api.reload('18d8b3e9', __exports__)
  }
  
  module.hot.accept("./TrfDateInput.vue?vue&type=template&id=18d8b3e9&scoped=true", () => {
    console.log('re-render')
    api.rerender('18d8b3e9', render)
  })

}


export default __exports__